// <GENERATED-CODE>
// Generated from Java using 'npm run generate:ts'

const FILL_STYLE_VALUES = [
  'SOLID',
  'TRANSPARENT',
  'HORIZONTAL',
  'HORIZONTAL_NARROW',
  'HORIZONTAL_WIDE',
  'VERTICAL',
  'VERTICAL_NARROW',
  'VERTICAL_WIDE',
  'DIAGONAL_UP',
  'DIAGONAL_UP_NARROW',
  'DIAGONAL_UP_WIDE',
  'DIAGONAL_DOWN',
  'DIAGONAL_DOWN_NARROW',
  'DIAGONAL_DOWN_WIDE',
  'CROSS',
  'CROSS_NARROW',
  'CROSS_WIDE',
  'DIAGONAL_CROSS',
  'DIAGONAL_CROSS_NARROW',
  'DIAGONAL_CROSS_WIDE',
  'GRAY_WIDE',
  'LIGHT_GRAY',
  'GRAY',
  'DARK_GRAY'
] as const;

/** @see net/disy/gis/gisterm/gfx/common/fill/FillStyle.java */
export type FillStyle = typeof FILL_STYLE_VALUES[number];

export const FillStyle = {
  values: FILL_STYLE_VALUES as readonly FillStyle[]
} as const;

// </GENERATED-CODE>
